import '../styles/App.css'
import '../styles/AboutMe.css'

import { TargetAboutMe } from './ui/TargetAboutMe.jsx';

import iconQuienSoy from '../assets/icon-quien-soy.svg';
import iconMiCarrera from '../assets/icon-mi-carrera.svg';
import iconHobbies from '../assets/icon-hobbies.svg';

export function AboutMe(){
  return(
    <section id="about" className="about-me">
      <h3 className="title">Sobre mi</h3>
      <div className="about-me-content">

      <TargetAboutMe 
        icon={iconQuienSoy}
        subtitle="¿Quién soy?"
        text={<p className="text">¡Hola! Mi nombre es Cristian Becerra pero puedes llamarme <b>Bece</b>. Tengo 25 años y soy un apasionado por el mundo de la tecnología.</p>}
      />

      <TargetAboutMe 
        icon={iconMiCarrera}
        subtitle="Mi carrera"
        text={<p className="text">A fines del 2014 comencé a estudiar <b>Ingeniería Informática y de Sistemas</b> en la Universidad Nacional de San Antonio Abad del Cusco (UNSAAC) y de forma <b>autodidacta</b> me centro en aprender y mejorar mis habilidades como <b>Web Developer</b>.</p>}
      />

      <TargetAboutMe 
        icon={iconHobbies} 
        subtitle="Aprendizaje"
        text={<p className="text">Actualmente, de forma autodidacta, estoy aprendiendo sobre <b>React.js</b> y <b>. Net Core 6</b>.</p>}
      />

      </div>
    </section>
  );
}